<template>
  <div class="page_tePaymentList">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="100px">
            <!-- <el-form-item label="打款公司" size="small">
              <el-select v-model="listQuery.remitAgency" placeholder="" size="small" style="width: 180px;" clearable filterable>
                <el-option v-for="(item, index) in legList" :key="index" :label="item.CompanyName" :value="item.CompanyName"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="暂支人" size="small">
              <el-select v-model="listQuery.applyUserNameId" placeholder="" clearable size="small" style="width: 180px;" filterable @change="getList">
                <el-option v-for="(item,index) in customerList" :key="index" :label="item.Username" :value="item.Userid"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="责任人" size="small" v-if="activeName=='待核销'">
              <el-select v-model="listQuery.PersonRespons" placeholder="" clearable size="small" style="width: 180px;" filterable>
                <el-option v-for="(item,index) in customerList" :key="index" :label="item.Username" :value="item.Userid"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="申请时间" size="small">
              <div class="flex">
                <el-date-picker v-model="listQuery.ApplyTimeStart" type="date" value-format="yyyy-MM-dd" size="small" style="width: 130px;">
                </el-date-picker>
                <div style="margin: 0 5px;">~</div>
                <el-date-picker v-model="listQuery.ApplyTimeEnd" type="date" value-format="yyyy-MM-dd" size="small" style="width: 130px;">
                </el-date-picker>
              </div>
            </el-form-item>
          </el-form>
          <div class="screenInput">
            <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
              <i class="i_txt" @click="dropDownScreen">{{ showDropScreen == 1 ? '收起' : '更多' }}<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen == 1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="100px">
          <div>
            <el-form-item label="服务中心/分公司" size="small" label-width="127px">
              <el-input v-model="listQuery.serviceCenterOrCompany" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="申请公司" size="small">
              <el-select v-model="listQuery.applyCompany" placeholder="" size="small" style="width: 180px;" clearable filterable>
                <el-option v-for="(item, index) in legList" :key="index" :label="item.CompanyName" :value="item.CompanyName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="暂支分类" size="small">
              <el-select v-model="listQuery.advanceType" placeholder="" clearable filterable style="width:180px">
                <el-option value="一般暂支"></el-option>
                <el-option value="西南暂支"></el-option>
                <el-option value="工伤/工资暂支"></el-option>
                <el-option value="供应商返费暂支"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="收款银行" size="small" label-width="127px">
              <el-input v-model="listQuery.depositBank" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="收款账号" size="small">
              <el-input v-model="listQuery.receiptAccount" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="收款帐号名称" size="small">
              <el-input v-model="listQuery.receiptAccountName" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="打款公司" size="small" label-width="127px">
              <el-select v-model="listQuery.remitAgency" placeholder="" size="small" style="width: 180px;" clearable filterable>
                <el-option v-for="(item, index) in legList2" :key="index" :value="item.comp"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="项目名称" size="small">
              <el-select v-model="listQuery.projectName" placeholder="" value-key="Projectid" size="small" style="width: 180px;" clearable filterable>
                <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item.StrprojectName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="申请部门" size="small">
              <el-input v-model="listQuery.applyDep" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="暂支编号" size="small" label-width="127px">
              <el-input v-model="listQuery.advanceNum" size="small" clearable style="width:180px" @keyup.enter.native="getList"></el-input>
            </el-form-item>
            <el-form-item label="OA编号" size="small">
              <el-input v-model="listQuery.oanum" size="small" clearable style="width:180px" @keyup.enter.native="getList"></el-input>
            </el-form-item>
            <el-form-item label="费用名称" size="small">
              <el-input v-model="listQuery.costName" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="申请金额" size="small" label-width="127px">
              <el-input v-model="listQuery.TotalFees" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="实发金额" size="small">
              <el-input v-model="listQuery.RemittanceAmount" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="是否紧急" size="small" v-if="activeName == '待打款'">
              <el-select v-model="listQuery.notifyLevel" placeholder="" size="small" style="width: 180px;" clearable filterable>
                <el-option label="是" :value="1"></el-option>
                <el-option label="否" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="合作账户户名" size="small" label-width="127px" v-if="activeName == '打款成功' || activeName == '打款失败'">
              <el-input v-model="listQuery.CooperatAccountName" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" plain @click="resetHandle()">清空</el-button>
        <el-button size="small" type="info" plain @click="showDropScreen = -1">关闭</el-button>
        <el-button v-preventReClick size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>收支</el-breadcrumb-item>
          <el-breadcrumb-item>暂支</el-breadcrumb-item>
          <el-breadcrumb-item>{{ activeName }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" type="card" @tab-click="changeTab">
          <el-tab-pane :label="'待打款（' + num1 + '）'" name="待打款"></el-tab-pane>
          <el-tab-pane :label="'打款中（' + num9 + '）'" name="打款中"></el-tab-pane>
          <el-tab-pane label="复核打款" name="复核打款"></el-tab-pane>
          <el-tab-pane :label="'打款成功（' + num3 + '）'" name="打款成功"></el-tab-pane>
          <el-tab-pane :label="'打款失败（' + num2 + '）'" name="打款失败"></el-tab-pane>
          <el-tab-pane :label="'待核销（' + num4 + '）'" name="待核销"></el-tab-pane>
          <el-tab-pane :label="'部门审核（' + num5 + '）'" name="部门审核"></el-tab-pane>
          <el-tab-pane :label="'财务核销（' + num6 + '）'" name="财务核销"></el-tab-pane>
          <el-tab-pane :label="'核销记录（' + num7 + '）'" name="核销记录"></el-tab-pane>
          <el-tab-pane :label="'核销完毕（' + num8 + '）'" name="核销完毕"></el-tab-pane>
          <el-tab-pane label="财务成本" name="财务成本" v-if="checkPermission(['finCost'], permissionLists)"></el-tab-pane>
        </el-tabs>
        <div class="ftabBtn flex">
          <el-popconfirm :title="'请确定选中的' + multipleSelection.length + '条是否确认打款成功？'" @confirm="handel('1')" style="margin-left: 10px;" v-if="(activeName == '待打款'|| activeName == '打款中') && checkPermission(['handelRegist'], permissionLists)">
            <el-button type="success" slot="reference" size="small">确认打款成功</el-button>
          </el-popconfirm>
          <el-popconfirm :title="'请确定选中的' + multipleSelection.length + '条是否确认打款失败？'" @confirm="handel('0')" style="margin: 0 10px;" v-if="(activeName == '待打款' || activeName == '打款成功'|| activeName == '打款中') && checkPermission(['handelRegist'], permissionLists)">
            <el-button type="warning" slot="reference" size="small">确认打款失败</el-button>
          </el-popconfirm>
          <el-button type="danger" size="small" v-if="activeName == '待打款' && checkPermission(['tePaymentList_payment_pay'], permissionLists)" @click="coppBatchPay">合作账号批量打款</el-button>
          <el-button type="success" size="small" v-if="activeName == '打款成功'" @click="importOffPayData">导入线下打款信息</el-button>
          <el-button type="success" size="small" v-if="activeName == '打款失败'" @click="importOffPayData">导入线下打款失败信息</el-button>
          <!-- <el-button type="warning" size="small" v-if="activeName == '待核销'" @click="importOffPayData">提交核销</el-button> -->
          <el-button type="primary" size="small" @click="exportList">导出</el-button>
          <el-badge :value="writeOffBatchList.length" class="item" style="margin-left:10px" v-if="activeName=='待核销' && checkPermission(['tePaymentList_writeOff_toWriteoff'], permissionLists)">
            <el-button type="warning" size="small" @click="writeOffBatch">批量核销</el-button>
          </el-badge>

          <div class="payTips" v-if="activeName=='打款成功'">注：核销请前往“待核销”核销</div>
        </div>
        <el-tabs v-model="activeName2" @tab-click="changeTab2" v-if="activeName == '待核销'">
          <el-tab-pane :label="'待核销（' + num4 + '）'" name="0"></el-tab-pane>
          <el-tab-pane :label="'核销被退回（' + num8back + '）'" name="1"></el-tab-pane>
        </el-tabs>
        <div class="tips" v-if="activeName=='待核销'">点击“+”即可展开</div>
        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:100%" @selection-change="handleSelectionChange" v-if="activeName=='待打款' || activeName=='打款成功' || activeName=='打款失败'|| activeName=='打款中'|| activeName=='复核打款'">
          <el-table-column type="selection" align="center" width="45" fixed="left">
          </el-table-column>
          <el-table-column prop="advanceNum" label="暂支编号" min-width="185" :show-overflow-tooltip="true" fixed="left">
            <template slot-scope="{row}">
              <div class="badgeItem" v-if="activeName=='待打款' && row.notifyLevel==1">
                <el-badge value="紧急" class="item">
                  <span>{{ row.advanceNum }}</span>
                </el-badge>
              </div>
              <div v-else style="text-align: center;">{{ row.advanceNum }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="busNum" label="CBS审批号" min-width="180" :show-overflow-tooltip="true" align="center" v-if="activeName=='打款中'">
          </el-table-column>
          <el-table-column prop="oanum" label="OA编号" min-width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="returnReason" label="退回原因" min-width="120" :show-overflow-tooltip="true" align="center" v-if="activeName=='打款失败'">
          </el-table-column>
          <el-table-column prop="remitAgency" label="打款公司" min-width="240" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="applyUserName" label="申请人" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="advanceType" label="暂支分类" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="payErrMsg" label="失败原因" min-width="180" :show-overflow-tooltip="true" align="center" v-if="activeName=='打款失败'">
          </el-table-column>
          <el-table-column prop="processState" label="是否需要核销" min-width="120" :show-overflow-tooltip="true" align="center" v-if="activeName=='打款成功'">
            <template slot-scope="{row}">{{row.processState=='1' ? '需要核销' : '无需核销'}}</template>
          </el-table-column>
          <el-table-column prop="applyTime" label="申请时间" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>{{row.applyTime ? row.applyTime.split('T')[0] : ''}}</template>
          </el-table-column>
          <el-table-column prop="applyCompany" label="申请公司" min-width="150" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="applyDep" label="申请部门" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="serviceCompany" label="服务公司" min-width="150" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="projectName" label="服务客户项目" min-width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="serviceCenterOrCompany" label="服务中心/分公司" min-width="160" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="totalFees" label="申请金额" min-width="100" :show-overflow-tooltip="true" align="center" v-if="activeName=='待打款'">
          </el-table-column>
          <el-table-column prop="costName" label="费用名称" min-width="100" :show-overflow-tooltip="true" align="center" v-if="activeName=='待打款'">
          </el-table-column>
          <el-table-column prop="remitMode" label="打款方式" min-width="100" :show-overflow-tooltip="true" align="center" v-if="activeName=='打款成功' || activeName=='打款失败'">
          </el-table-column>
          <el-table-column prop="remittanceAmount" label="打款金额" min-width="100" :show-overflow-tooltip="true" align="center" v-if="activeName=='打款成功' || activeName=='打款失败'">
          </el-table-column>
          <el-table-column prop="paymentTime" label="打款时间" min-width="140" :show-overflow-tooltip="true" align="center" v-if="activeName=='打款成功'">
          </el-table-column>
          <el-table-column prop="paymentTime" label="打款失败时间" min-width="140" :show-overflow-tooltip="true" align="center" v-if="activeName=='打款失败'">
          </el-table-column>
          <el-table-column prop="updateRecord" label="修改记录" min-width="200" :show-overflow-tooltip="true" align="center" v-if="activeName=='打款失败'">
          </el-table-column>
          <el-table-column prop="receiptAccountName" label="收款帐号名称" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="receiptAccount" label="收款帐号" min-width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="depositBank" label="开户银行" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>

          <el-table-column prop="descFees" label="费用说明" min-width="200" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="fileName" label="附件" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>
              <span @click="toDownFile(row.fileUrl)" class="blueName cp">{{row.fileName && row.fileUrl ? row.fileName : ''}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="oaApprovalRemarks" label="OA审批备注" :min-width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center" :min-width="activeName=='待打款' ? '100' : activeName=='待核销' ? '280' : '200'" fixed="right">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-button type="text" @click="toDtl(row,'dtl')">详情</el-button>
                <el-button type="text" @click="jxjApprove(row,1)" size="small" v-preventReClick v-if="activeName=='复核打款' && row.fileUrl && checkPermission(['tePaymentList_payment_pay'], permissionLists)">杰小金打款</el-button>
                <el-button type="text" @click="jxjApprove(row,2)" size="small" v-preventReClick v-if="activeName=='复核打款' && row.fileUrl && checkPermission(['tePaymentList_payment_pay'], permissionLists)">撤回</el-button>
                <el-button type="text" size="small" v-preventReClick @click="viewPic(row)" v-if="activeName=='复核打款' && row.fileUrl && checkPermission(['tePaymentList_payment_pay'], permissionLists)">查看截图</el-button>
                <!-- <el-button type="text" size="small" v-preventReClick @click="dowFile(row)" v-if="activeName=='复核打款' && row.fileUrl && checkPermission(['tePaymentList_payment_pay'], permissionLists)">下载</el-button> -->
                <el-button type="text" @click="toPayment(row)" v-if="activeName=='待打款' && checkPermission(['tePaymentList_payment_pay'], permissionLists)">打款</el-button>
                <el-popconfirm title="请确认是否需要核销？" @confirm="WriteOffRequired(row,'1')" style="margin: 0 10px;" v-if="activeName=='打款成功' && row.writeOffMark=='0' && checkPermission(['tePaymentList_payFail_needWriteoff'], permissionLists)">
                  <el-button type="text" slot="reference">需要核销</el-button>
                </el-popconfirm>
                <el-popconfirm title="请确认是否无需核销？" @confirm="WriteOffRequired(row,'0')" style="margin: 0 10px;" v-if="activeName=='打款成功' && row.writeOffMark=='1' && checkPermission(['tePaymentList_payFail_noNeedWriteoff'], permissionLists)">
                  <el-button type="text" slot="reference">无需核销</el-button>
                </el-popconfirm>
                <el-button type="text" v-if="activeName=='打款成功' && row.remitMode == 'CBS' && checkPermission(['tePaymentList_payFail_down'], permissionLists)" @click="downReceipt(row)">下载回单</el-button>
                <el-button type="text" v-if="activeName=='打款失败' && checkPermission(['tePaymentList_payFail_edit'], permissionLists)" @click="editFailInfo(row)">修改信息</el-button>
                <el-button type="text" v-if="activeName=='打款失败' && checkPermission(['tePaymentList_payment_pay'], permissionLists)" @click="toPayment(row)">重新打款</el-button>
                <!-- <el-popconfirm title="请确认是否提交核销？" @confirm="SubmitWriteoff(row)" style="margin-left:10px;" v-if="activeName=='待核销'">
                  <el-button type="text" slot="reference">提交核销</el-button>
                </el-popconfirm> -->
                <!-- <el-button type="text" v-if="activeName=='待核销'" @click="toDtl(row,'writeOff')">提交核销</el-button> -->
                <el-popconfirm title="请确认是否无需核销？" @confirm="WriteOffRequired(row,'0')" style="margin: 0 10px;" v-if="activeName=='待核销' && row.writeOffMark=='1' && checkPermission(['tePaymentList_payFail_noNeedWriteoff'], permissionLists)">
                  <el-button type="text" slot="reference">无需核销</el-button>
                </el-popconfirm>
                <el-button type="text" v-if="activeName=='待核销' && checkPermission(['tePaymentList_writeOff_changePR'], permissionLists)">变更责任人</el-button>
              </div>
            </template>
          </el-table-column>

        </el-table>

        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:100%" key="writeOff" ref="writeOff" @selection-change="handleSelectionChange" @expand-change="handleExpandChange" v-else>
          <el-table-column type="selection" align="center" width="45" fixed="left">
          </el-table-column>
          <el-table-column key="expand" type="expand" fixed="left" v-if="activeName=='待核销'">
            <template slot-scope="props">
              <div class="expandTable">
                <el-table :data="expandTable" class="doc_table">
                  <el-table-column prop="advanceNum" label="核销编号" width="100" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="writtenAmount" label="核销金额" width="100" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="writtenTime" label="核销时间" width="100" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="writtenAuditor" label="核销审核人" width="100" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="applyUserName" label="核销提交人" width="100" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="reimbTime" label="核销申请时间" width="160" :show-overflow-tooltip="true" align="center">
                    <template slot-scope={row}>{{row.reimbTime ? row.reimbTime.replace('T',' ') : ''}}</template>
                  </el-table-column>
                  <el-table-column prop="applyRemark" label="核销申请备注" width="200" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column label="操作" width="160" align="center" fixed="right">
                    <template slot-scope={row}>
                      <div class="injuryTabBtn">
                        <el-button type="text" v-if="activeName=='待核销' && checkPermission(['edit'], permissionLists) && (row.processState=='1'|| row.processState=='5')" @click="toDtl2(row,'writeOff')">编辑</el-button>
                        <el-popconfirm title="请确认是否提交核销？" @confirm="SubmitWriteoff(row)" style="margin-left:10px;" v-if="
                        checkPermission(['tePaymentList_writeOff_toWriteoff'], permissionLists) && (row.processState=='1'|| row.processState=='5')">
                          <el-button type="text" slot="reference">提交核销</el-button>
                        </el-popconfirm>
                        <el-popconfirm title="请确认是否作废？" @confirm="del(row)" style="margin: 0 10px;" v-if="checkPermission(['del'], permissionLists) && (row.processState=='1'|| row.processState=='5')">
                          <el-button type="text" slot="reference">作废</el-button>
                        </el-popconfirm>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="advanceNum" label="暂支编号" min-width="160" :show-overflow-tooltip="true" align="center" fixed="left">
          </el-table-column>
          <el-table-column prop="oanum" label="OA编号" min-width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="remitAgency" label="打款公司" min-width="240" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="costName" label="费用名称" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="tobeWrittenOffAmount" label="待核销金额" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="recentlySubmittedAmount" v-if="activeName=='待核销'" label="最近提交核销金额" min-width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="recentlySubmittedTime" v-if="activeName=='待核销'" label="最近提交核销时间" min-width="150" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>{{row.recentlySubmittedTime ? row.recentlySubmittedTime.replace('T',' ') : ''}}</template>
          </el-table-column>
          <el-table-column prop="writtenAmount" v-if="activeName=='财务核销'||activeName=='核销记录'||activeName=='核销完毕'" label="本次提交核销金额" min-width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="applyTime" label="本次提交核销时间" v-if="activeName=='财务核销'||activeName=='核销记录'||activeName=='核销完毕'" min-width="150" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>{{row.applyTime ? row.applyTime.replace('T',' ') : ''}}</template>
          </el-table-column>
          <el-table-column prop="remittanceAmount" label="打款金额" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="verifNum" label="核销单号" min-width="140" :show-overflow-tooltip="true" align="center" v-if="activeName=='财务核销'">
          </el-table-column>
          <el-table-column prop="receiptAccountName" label="收款帐号名称" min-width="240" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="receiptAccount" label="收款帐号" min-width="160" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="depositBank" label="开户银行" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="applyCompany" label="申请公司" min-width="150" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="applyDep" label="申请部门" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="applyUserName" label="暂支人" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="personResponsName" label="核销责任人" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="serviceCompany" label="服务公司" min-width="150" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="projectName" label="服务客户项目" min-width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="name" label="打款银行" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="name" label="银行流水号" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="name" label="银行回单" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="fileName" label="附件" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="oaApprovalRemarks" label="OA审批备注" :min-width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center" :min-width="activeName=='待核销' ? '280' : activeName=='财务核销' ? '220' : '200'" fixed="right" v-if="activeName != '核销完毕'">
            <template slot-scope={row}>
              <div class="injuryTabBtn" v-if="activeName2=='0'">
                <el-button type="text" @click="toDtl(row,'dtl')" v-if="activeName=='待核销'">详情</el-button>
                <el-button type="text" @click="toDtl2(row,'dtl')" v-if="activeName!='待核销'">{{activeName=='财务核销' ? '明细（打印/下载）' : '查看'}}</el-button>
                <el-button type="text" @click="viewDtl(row)" v-if="activeName=='待核销'">明细 </el-button>
                <el-button type="text" v-if="activeName=='待核销' && checkPermission(['tePaymentList_writeOff_toWriteoff'], permissionLists)" @click="towriteOff(row,'writeOff')">核销</el-button>
                <el-popconfirm title="请确认是否无需核销？" @confirm="WriteOffRequired(row,'0')" style="margin: 0 10px;" v-if="activeName=='待核销' && row.writeOffMark=='1' && checkPermission(['tePaymentList_payFail_noNeedWriteoff'], permissionLists)">
                  <el-button type="text" slot="reference">无需核销</el-button>
                </el-popconfirm>
                <el-button type="text" v-if="activeName=='待核销' && checkPermission(['tePaymentList_writeOff_changePR'], permissionLists)" @click="changePersonRespons(row)">变更责任人</el-button>
                <el-button type="text" v-if="activeName=='部门审核' && checkPermission(['tePaymentList_depApprove_approve'], permissionLists)" @click="toDtl2(row,'approve')">审批</el-button>
                <el-button type="text" v-if="activeName=='财务核销' && checkPermission(['tePaymentList_finApprove_approve'], permissionLists)" @click="toDtl2(row,'approve')">审批</el-button>
                <el-popconfirm title="请确认是否撤销？" @confirm="revoke(row)" style="margin: 0 10px;" v-if="activeName=='财务核销'|| activeName=='部门审核'">
                  <el-button type="text" slot="reference">撤销</el-button>
                </el-popconfirm>
                <!-- <el-button type="text" @click="editCostType(row)" v-if="activeName=='待核销'">修改费用类型</el-button> -->
              </div>
              <div class="injuryTabBtn" v-if="activeName2=='1'">
                <el-button type="text" v-if="activeName=='待核销' && checkPermission(['edit'], permissionLists) && (row.processState=='1'|| row.processState=='5')" @click="toDtl2(row,'writeOff')">编辑</el-button>
                <el-popconfirm title="请确认是否提交核销？" @confirm="SubmitWriteoff(row)" style="margin-left:10px;" v-if="
                        checkPermission(['tePaymentList_writeOff_toWriteoff'], permissionLists) && (row.processState=='1'|| row.processState=='5')">
                  <el-button type="text" slot="reference">提交核销</el-button>
                </el-popconfirm>
                <el-popconfirm title="请确认是否作废？" @confirm="del(row)" style="margin: 0 10px;" v-if="checkPermission(['del'], permissionLists) && (row.processState=='1'|| row.processState=='5')">
                  <el-button type="text" slot="reference">作废</el-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>

        </el-table>

        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.PageModel.Page" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="导入线下打款信息" :visible.sync="showImportOff" width="500px">
      <div>
        <el-form label-width="125px">
          <el-form-item label="导入模板">
            <el-button type="text" @click="downTemp()">下载</el-button>
          </el-form-item>
          <el-form-item label="导入线下打款信息">
            <el-upload class="upload-demo" action="" :on-remove="handleRemove" multiple :limit="1" :auto-upload="false" :on-exceed="handleExceed" :on-change="handleUploadOff" accept=".xlsx,.xls" :file-list="fileListOff">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button style="margin-left:10px;" size="small" @click="showImportOff = false">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmImportOff">确 认</el-button>
      </span>
    </el-dialog>

    <el-dialog title="修改收款方账户信息" :visible.sync="showEditFailInfo" width="550px">
      <el-form :model="failForm" ref="formData" :rules="failRules" label-width="110px" v-if="showEditFailInfo">
        <el-form-item label="银行户名" prop="AccountName">
          <el-input v-model="failForm.AccountName" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="银行卡帐号" prop="BankAccount">
          <el-input v-model="failForm.BankAccount" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="开户行" prop="DepositBank">
          <el-input v-model="failForm.DepositBank" style="width:300px" size="small"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEditFailInfo = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmEdit" :loading="isBtnLoading">提 交</el-button>
      </span>
    </el-dialog>
    <el-dialog title="变更责任人" :visible.sync="showChangePR" width="400px">
      <el-form :model="prForm" ref="prForm" label-width="80px">
        <el-form-item label="责任人" prop="personResponsUserId">
          <el-select v-model="prForm.personResponsUserId" placeholder="" clearable size="small" style="width: 220px;" filterable>
            <el-option v-for="(item,index) in customerList" :key="index" :label="item.Username" :value="item.Userid"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showChangePR = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmChangePR" :loading="isBtnLoading">确 认</el-button>
      </span>
    </el-dialog>

    <el-dialog title="修改费用类型" :visible.sync="showCostType" width="350px">
      <el-form :model="prForm" ref="prForm" label-width="80px">
        <el-form-item label="费用类型">
          <el-input v-model="costForm.TypeCost" style="width:220px" size="small"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showCostType = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmEditCostType" :loading="isBtnLoading">确 认</el-button>
      </span>
    </el-dialog>

    <el-dialog title="合作账户批量打款提示" :visible.sync="showCoopTips" width="500px">
      <div>合作账户批量打款要求合作账户相同，请确认是否满足？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showCoopTips = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmCoopBatchPay" :loading="isBtnLoading">满足，确认</el-button>
      </span>
    </el-dialog>

    <el-dialog title="批量核销" :visible.sync="showWriteOffBatch" width="1100px">
      <el-table :data="writeOffBatchList" style="width:100%">
        <el-table-column prop="advanceNum" label="暂支编号" min-width="160" :show-overflow-tooltip="true" align="center" fixed="left">
        </el-table-column>
        <el-table-column prop="oanum" label="OA编号" min-width="120" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="remitAgency" label="打款公司" min-width="240" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="remittanceAmount" label="打款金额" min-width="80" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="tobeWrittenOffAmount" label="待核销金额" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="receiptAccountName" label="收款账号名称" min-width="180" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="applyUserName" label="暂支人" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column label="操作" min-width="80">
          <template slot-scope="{row,$index}">
            <div class="injuryTabBtn">
              <el-button type="text" @click="delItem(row,$index)">移除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showWriteOffBatch = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmBatchWO" :loading="isBtnLoading">批量核销</el-button>
      </span>
    </el-dialog>

    <el-dialog title="核销明细" :visible.sync="showWRDtl" width="1100px">
      <el-table :data="expandTable" class="doc_table">
        <el-table-column prop="advanceNum" label="核销编号" min-width="140" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="writtenAmount" label="核销金额" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="writtenTime" label="核销时间" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="writtenAuditor" label="核销审核人" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="applyUserName" label="核销提交人" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="reimbTime" label="核销申请时间" min-width="160" :show-overflow-tooltip="true" align="center">
          <template slot-scope={row}>{{row.reimbTime ? row.reimbTime.replace('T',' ') : ''}}</template>
        </el-table-column>
        <el-table-column prop="applyRemark" label="核销申请备注" min-width="200" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column label="操作" width="160" align="center">
          <template slot-scope={row}>
            <div class="injuryTabBtn">
              <el-button type="text" v-if="activeName=='待核销' && checkPermission(['edit'], permissionLists) && (row.processState=='1'|| row.processState=='3' || row.processState=='5')" @click="toDtl2(row,'writeOff')">编辑</el-button>
              <el-popconfirm title="请确认是否提交核销？" @confirm="SubmitWriteoff(row)" style="margin-left:10px;" v-if="
                        checkPermission(['tePaymentList_writeOff_toWriteoff'], permissionLists)">
                <el-button type="text" slot="reference">提交核销</el-button>
              </el-popconfirm>
              <el-popconfirm title="请确认是否作废？" @confirm="del(row)" style="margin: 0 10px;" v-if="checkPermission(['del'], permissionLists)">
                <el-button type="text" slot="reference">作废</el-button>
              </el-popconfirm>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showWRDtl = false" size="small">关 闭</el-button>
      </span>
    </el-dialog>

    <el-dialog title="获取验证码" :visible.sync="showSms" width="500px" :show-close="false">
      <el-form>
        <el-form-item label="请输入验证码" label-width="100px">
          <el-input v-model="verifCode" style="width:120px" size="small"></el-input>
          <el-button type="primary" v-preventReClick size="small" style="margin-left:10px" :disabled="countdown>0" @click="sendSms">{{countdown == 0 ? '发送短信' : '重新发送（' + countdown + '）'}}</el-button>
        </el-form-item>
      </el-form>
      <div>注:验证码将发送到您的企微通知</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showSms = false" size="small">取 消</el-button>
        <el-button type="danger" v-preventReClick style="margin-left:10px;" size="small" @click="checkSms" :loading="isBtnLoading">确认</el-button>
      </span>
    </el-dialog>

    <div v-if="picPreviewVisible" class="image-preview-wrapper">
      <el-image-viewer :on-close="closeImageViewer" :url-list="[picUrl]" />
    </div>
  </div>
</template>

<script>
  import xz from "../../common";
  import moment from 'moment';
  import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    components: {
      ElImageViewer
    },
    data() {
      return {
        listQuery: {
          PageModel: {
            Rows: 10,
            Page: 1,
            OrderInput: [{
              property: "createTime",
              order: 1
            }]
          },
          id: '',
          oanum: '', //OA编号
          advanceNum: '', //暂支编号
          busiType: '1', //暂支分类
          applyTime: '', //申请时间
          applyCompany: '', //申请公司
          applyDep: '', //申请部门
          applyDepCode: '',
          notifyLevel: null,
          applyUserName: '', //申请人
          serviceCompany: '', //服务公司
          projectName: '', //项目
          totalFees: '', //费用金额
          costName: '', //费用名称
          applyFee: '', //申请金额
          PersonRespons: '', //责任人id
          receiptAccountName: '', //收款账户名
          receiptAccount: '', //收款账户
          depositBank: '', //收款开户行
          remitAgency: '', //打款公司
          descFees: '', ////费用说明
          ApplyTimeEnd: '',
          ApplyTimeStart: '',
          oaApprovalRemarks: '', //OA审批备注
          processState: '',
          RemittanceAmount: '', //实发金额
          CooperatAccountName: '',
          TotalFees: '', //申请金额
          PayResult: '3',
          applyUserNameId: '',
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
        },
        writeOffBatchList: [], //批量核销列表
        showWriteOffBatch: false,
        activeName: '待核销',
        legList: [],
        legList2: [],
        showCostType: false,
        costForm: {
          Id: '',
          Userid: '',
          TypeCost: ''
        },
        showDropScreen: -1,
        tableData: [],
        roletype: localStorage.loginRoletype,
        totalCount: 0,
        loading: false,
        proNameList: [], //项目列表
        multipleSelection: [],
        showImportOff: false,
        offURL: '',
        fileListOff: [],
        isBtnLoading: false,
        expandTable: [], //展开的表格
        customerList: [], //客服列表
        expQuery: {
          PageModel: {
            Rows: 10,
            Page: 1,
            OrderInput: []
          },
          ProcessState: '',
          advanceId: '',
          BusiType: '1',
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
        },
        showEditFailInfo: false,
        showChangePR: false,
        prForm: {
          id: '',
          personResponsUserId: '',
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype
        },
        failForm: {
          AccountName: '',
          BankAccount: '',
          DepositBank: '',
          Type: '1', //1为暂支打款，2为日志报销打款
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
          Id: ''
        },
        showCoopTips: false,
        permissionLists: [],
        num1: 0, //待打款
        num2: 0, //打款失败
        num3: 0, //打款成功 
        num4: 0, //待核销
        num5: 0, //部门审核
        num6: 0, //财务核销 
        num7: 0, //暂支报销单完成数
        num8: 0, //暂支单核销完成数
        num9: 0, //打款中
        num8back: 0, //暂支报销单被退回
        needLoading: false,
        activeName2: '0',
        showWRDtl: false,
        picUrl: '',
        picPreviewVisible: false,
        showSms: false,
        verifCode: '',
        apptype: 0,
        countdown: 0,
        timer: null,
        appId: '',
        failRules: {
          AccountName: {
            required: true,
            message: '请输入银行户名',
            trigger: 'blur'
          },
          BankAccount: {
            required: true,
            message: '请输入银行卡帐号',
            trigger: 'blur'
          },
          DepositBank: {
            required: true,
            message: '请输入开户行',
            trigger: 'blur'
          },
        }
      }
    },
    created() {
      if (this.activeName == '待核销' && localStorage.roleName.indexOf('财务') == -1 && localStorage.roleName.indexOf('管理员') == -1) {
        // this.listQuery.applyUserNameId = Cookies.get("userid-b");
        // this.listQuery.personResponsName = localStorage.userName;
        this.listQuery.PersonRespons = Cookies.get("userid-b");
      }
      if (this.$route.query.activeName != undefined && this.$route.query.activeName) {
        this.activeName = this.$route.query.activeName;
        this.changeTab();
      } else {
        this.changeTab();
      }
      this.getProList();
      this.getlegalsubjectlist();
      this.getlegalsubjectlist2();
      this.getMemberList();
      this.getButtonPower();
    },
    mounted() {
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible' && this.needLoading) {
          // console.log('visible')
          // 可见时，重新查询。
          // 请求表格数据方法
          this.getList();
          this.needLoading = false;
        } else {
          // console.log('hidden')
        }
      })
    },
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        let that = this
        let butQuery = {
          path: '/tePaymentList',
          powerEnName: 'tePaymentList'
        }
        xz.getbtnPowerIdBypage(butQuery).then(res => {
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                that.permissionLists.push(element.Enname);
              }
              // console.log(that.permissionLists)
            } else {
              this.permissionLists = []
            }
          } else {
            this.$message.error('获取按钮权限出错')
            this.permissionLists = []
          }
        })
      },
      isNull(o) {
        // console.log('isnull',o)
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == "NaN" ||
          o == '[{}]'
        );
      },
      // 获取人员列表
      getMemberList(type) {
        let data = {
          currpage: 1,
          perpage: 10000000,
          keyword: "",
          strWorkState: "",
          strstation: "",
          strorgancode: "",
        }
        xz.getauthUserInfoByorgancode(data).then((res) => {
          if (res.status == "ok") {
            this.customerList = res.msg;
          } else {
            this.customerList = [];
          }
        });
      },
      //获取法务主体列表
      getlegalsubjectlist() {
        let data = {
          pageNum: '1',
          pageSize: '10000'
        }
        xz.getlegalsubjectlist(data).then(res => {
          if (res.status == 'ok') {
            this.legList = res.data.data;
          } else {
            this.legList = [];
          }
        })
      },
      //获取暂支付款公司取频次高的公司列表
      getlegalsubjectlist2() {
        let str = 'GetAdvPayCompanyList'
        xz.AdvanceGetFun(str).then(res => {
          if (res.status == 'ok') {
            this.legList2 = res.data.payCompList;
          } else {
            this.legList2 = [];
          }
        })
      },
      //获取项目
      getProList() {
        let data = {
          projectname: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: this.roletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.proNameList = res.msg;
          } else {
            this.proNameList = [];
          }
        });
      },
      currentChange(val) {
        this.listQuery.PageModel.Page = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.PageModel.Page = 1;
        this.listQuery.PageModel.Rows = val;
        this.getList();
      },
      searchHandle() {
        this.listQuery.PageModel.Page = 1;
        this.getList();
      },
      getList() {
        if (this.activeName == '待打款' || this.activeName == '打款成功' || this.activeName == '打款中' || this.activeName == '打款失败' || this.activeName == '核销完毕' || this.activeName == '复核打款') {
          this.GetAdvancePageList();
        } else if (this.activeName == '部门审核' || this.activeName == '财务核销' || this.activeName == '核销记录') {
          this.WriteOffList();
        } else if (this.activeName == '待核销') {
          if (this.activeName2 == '0') {
            this.GetAdvancePageList();
          } else {
            this.WriteOffList();
          }
          this.getNum2();
        }
        this.getNumber();
      },
      getList2() {
        if (this.activeName2 == '0') {
          this.GetAdvancePageList();
        } else {
          this.WriteOffList();
        }
      },
      getNum2() {
        let data = {
          PageModel: {
            Rows: 10,
            Page: 1,
            OrderInput: []
          },
          ProcessState: '5',
          advanceNum: '',
          advanceId: '',
          BusiType: '1',
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
        }
        xz.WriteOffList(data).then(res => {
          if (res.status == 'ok') {
            this.num8back = res.data.pageModel.totalCount;
          } else {
            this.num8 = 0
          }
        })
      },
      GetAdvancePageList() {
        this.loading = true;
        xz.GetAdvancePageList(this.listQuery).then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data.data;
            this.totalCount = res.data.pageModel.totalCount;
            this.loading = false;
          } else {
            this.tableData = [];
            this.totalCount = 0;
            this.loading = false;
          }
        })
      },
      getNumber() {
        this.num1 = 0;
        this.num2 = 0;
        this.num3 = 0;
        this.num4 = 0;
        this.num5 = 0;
        this.num6 = 0;
        this.num7 = 0;
        this.num8 = 0;
        xz.AdvanceFun(this.listQuery, 'GetAdvCollect').then(res => {
          if (res.status == 'ok') {
            res.data.forEach(element => {
              if (element.type == '1') {
                this.num1 = element.count ? element.count : 0
              } else if (element.type == '2') {
                this.num2 = element.count ? element.count : 0
              } else if (element.type == '3') {
                this.num3 = element.count ? element.count : 0
              } else if (element.type == '4') {
                this.num4 = element.count ? element.count : 0
              } else if (element.type == '5') {
                this.num5 = element.count ? element.count : 0
              } else if (element.type == '6') {
                this.num6 = element.count ? element.count : 0
              } else if (element.type == '7') {
                this.num7 = element.count ? element.count : 0
              } else if (element.type == '8') {
                this.num8 = element.count ? element.count : 0
              } else if (element.type == '9') {
                this.num9 = element.count ? element.count : 0
              }
            });
          }
        })
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
        if (this.activeName == '待核销') {
          if (this.writeOffBatchList.length > 0) {
            let name = this.writeOffBatchList[0].remitAgency;
            let rname = this.writeOffBatchList[0].receiptAccountName;
            let canBatch = true;
            val.forEach(element => {
              if (name != element.remitAgency) {
                canBatch = false;
              }
              if (rname != element.receiptAccountName) {
                canBatch = false;
              }
            });
            if (canBatch) {
              this.writeOffBatchList = this.writeOffBatchList.concat(val);
              this.writeOffBatchList = this.unique(this.writeOffBatchList)
            } else {
              this.$message.warning('批量核销只能选择打款公司、收款账号名称都相同的单子')
            }
          } else {
            this.writeOffBatchList = val
          }

        }
      },
      //去重
      unique(arr) {
        const resList = new Map();
        return arr.filter(
          (arr) => !resList.has(arr.id) && resList.set(arr.id, 1)
        );
      },
      toDtl(row, type) {
        this.needLoading = true;
        const routerUrl = this.$router.resolve({
          path: '/tePaymentDtl',
          query: {
            id: row.id,
            type,
            activeName: this.activeName
          }
        });
        window.open(routerUrl.href, "_blank");
      },
      confirmBatchWO() {
        this.isBtnLoading = true;
        let arr = [];
        let arr2 = [];
        this.writeOffBatchList.forEach((element, index) => {
          arr.push(element.id);
          arr2.push(element.oanum);
          if (index == this.writeOffBatchList.length - 1) {
            this.isBtnLoading = false;
            this.$router.push({
              path: '/tePaymentDtl',
              query: {
                id: arr.toString(),
                type: 'writeOffBatch',
                oanum: arr2.toString(),
                activeName: this.activeName
              }
            })
          }
        });
      },
      //详情 核销 审批
      toDtl2(row, type) {
        this.needLoading = true;
        // if (type == 'approve') {
        const routerUrl = this.$router.resolve({
          path: "/tePaymentDtl",
          query: {
            id: row.advanceId,
            type,
            writeOffId: row.id,
            activeName: this.activeName
          }
        });
        window.open(routerUrl.href, "_blank");
      },
      writeOffBatch() {
        this.showWriteOffBatch = true;
      },
      towriteOff(row, type) {
        // this.$router.push({
        //   path: '/tePaymentDtl',
        //   query: {
        //     id: row.id,
        //     type,
        //     writeOffId: '',
        //     activeName: this.activeName
        //   }
        // })
        this.needLoading = true;
        const routerUrl = this.$router.resolve({
          path: "/tePaymentDtl",
          query: {
            id: row.id,
            type,
            writeOffId: '',
            activeName: this.activeName
          }
        });
        window.open(routerUrl.href, "_blank");
      },
      //打款
      toPayment(row) {
        this.needLoading = true;
        const routerUrl = this.$router.resolve({
          path: "/tePayment",
          query: {
            id: row.id
          }
        });
        window.open(routerUrl.href, "_blank");
      },
      changeTab() {
        this.activeName == '0';
        let modelQuery = {
          PageModel: {
            Rows: 10,
            Page: 1,
            OrderInput: [{
              property: "createTime",
              order: 1
            }]
          },
          id: '',
          oanum: this.listQuery.oanum, //OA编号
          advanceNum: this.listQuery.advanceNum, //暂支编号
          busiType: '1', //暂支分类
          applyTime: '', //申请时间
          applyCompany: '', //申请公司
          applyDep: '', //申请部门
          applyDepCode: '',
          applyUserName: '', //申请人
          serviceCompany: '', //服务公司
          projectName: this.listQuery.projectName, //项目
          totalFees: '', //费用金额
          costName: '', //费用名称
          applyFee: '', //申请金额
          receiptAccountName: '', //收款账户名
          receiptAccount: '', //收款账户
          depositBank: '', //收款开户行
          remitAgency: this.listQuery.remitAgency, //打款公司
          serviceCenterOrCompany: '',
          applyUserNameId: this.listQuery.applyUserNameId,
          PersonRespons: this.listQuery.PersonRespons,
          descFees: '', ////费用说明
          serviceCenterOrCompany: '', //服务中心
          oaApprovalRemarks: '', //OA审批备注
          processState: '',
          PayResult: '',
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
        }
        if (this.activeName == '待打款' || this.activeName == '打款成功' || this.activeName == '打款失败' || this.activeName == '打款中' || this.activeName == '复核打款') {
          this.listQuery = JSON.parse(JSON.stringify(modelQuery))
          this.listQuery.processState = '';
          this.listQuery.PayResult = this.activeName == '待打款' ? '3' : this.activeName == '打款成功' ? '1' : this.activeName == '打款失败' ? '2' : this.activeName == '打款中' ? '4' : '5';
          this.getList()
        } else if (this.activeName == '待核销') {
          this.listQuery = JSON.parse(JSON.stringify(modelQuery))
          this.listQuery.PayResult = '1';
          this.activeName2 = '0';
          this.listQuery.processState = '1';
          this.getList()
        } else if (this.activeName == '部门审核' || this.activeName == '财务核销' || this.activeName == '核销记录' || this.activeName == '核销完毕') {
          this.listQuery = {
            PageModel: {
              Rows: 10,
              Page: 1,
              OrderInput: [{
                property: "updataTime",
                order: 1
              }]
            },
            ProcessState: this.activeName == '部门审核' ? '2' : this.activeName == '财务核销' ? '3' : this.activeName == '核销完毕' ? '2' : this.activeName == '核销记录' ? '4' : '',
            advanceNum: '',
            applyUserNameId: this.listQuery.applyUserNameId,
            advanceId: '',
            remitAgency: this.listQuery.remitAgency,
            oanum: this.listQuery.oanum,
            BusiType: '1',
            userId: Cookies.get("userid-b"),
            roleType: localStorage.loginRoletype,
          }
          this.getList()
        } else if (this.activeName == '财务成本') {
          this.$router.push({
            path: '/finCost'
          })
        }
      },
      handel(type) {
        if (!this.loading) {
          if (this.multipleSelection.length > 0) {
            this.loading = true;
            let arr = [];
            this.multipleSelection.forEach((element, index) => {
              let d = {
                id: element.id,
                payResult: type, //1代表成功,0为失败
                BusiType: '1', //1暂支 2 工作日志
                TotalFees: element.totalFees, //打款金额
                ProcessState: '1', //是否需要核销，为1是需要核销，为0是不用核销
                UseFunds: '', //款项用途
                userId: Cookies.get("userid-b"),
                roleType: localStorage.loginRoletype
              }
              arr.push(d)
              if (index == this.multipleSelection.length - 1) {
                xz.remitAdvance(arr).then(res => {
                  try {
                    if (res.status == 'ok') {
                      this.$message.success('保存成功！');
                      this.getList();
                      this.loading = false;
                    } else {
                      this.loading = false;
                      this.getList();
                      this.$message.error(res.msg);
                    }
                  } catch {
                    this.$message.error('系统出错');
                    this.loading = false;
                  }
                })
              }
            });
          } else {
            this.$message.warning('请至少选择一条')
          }
        }
      },
      //导入线下打款信息
      importOffPayData() {
        this.showImportOff = true;
      },
      confirmImportOff() {
        if (this.offURL) {
          this.isBtnLoading = true;
          let data = {
            fileUrl: this.offURL,
            userId: Cookies.get("userid-b"),
            payResult: this.activeName == '打款成功' ? 1 : 0,
            roleType: localStorage.loginRoletype
          }
          xz.ImportOfflinePayment(data).then(res => {
            if (res.status == 'ok') {
              this.showImportOff = false;
              this.$message.success('保存成功');
              this.isBtnLoading = false;
            } else {
              this.showImportOff = false;
              this.$message.error(res.msg);
              this.isBtnLoading = false;
            }
          })
        }
      },
      //上传导入薪资表
      handleUploadOff(file, fileList) {
        const formData = new FormData();
        formData.append("pagename", "docinf");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        console.log("formData", formData);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.offURL = res;
          } else {
            this.offURL = ''
          }
        });
      },
      handleRemove(file) {
        this.offURL = '';
      },
      handleExceed() {
        this.$message.warning(`当前限制最多上传 1 个文件`);
      },
      //提交核销
      SubmitWriteoff(row) {
        if (!this.loading) {
          this.loading = true;
          let data = {
            id: row.id,
            type: '1', //1.为暂支，2为日志
            userId: Cookies.get("userid-b"),
            roleType: localStorage.loginRoletype
          }
          xz.SubmitWriteoff(data).then(res => {
            if (res.status == 'ok') {
              this.loading = false;
              this.$message.success('保存成功');
              this.getList();
            } else {
              this.$message.error(res.msg);
              this.loading = false;
              this.getList();
            }
          })
        }
      },
      //需要、无需 核销
      WriteOffRequired(row, writeOffMark) {
        if (!this.loading) {
          this.loading = true;
          let data = {
            id: row.id,
            writeOffMark,
            userId: Cookies.get("userid-b"),
            roleType: localStorage.loginRoletype
          }
          xz.NoWriteOffRequired(data).then(res => {
            if (res.status == 'ok') {
              this.loading = false;
              this.$message.success('操作成功');
              this.getList();
            } else {
              this.$message.error(res.msg);
              this.loading = false;
              this.getList();
            }
          })
        }
      },
      //展开表格
      handleExpandChange(row, rows) {
        if (rows.length > 1) {
          this.expandTable = []
          this.$refs.writeOff.toggleRowExpansion(rows[0]);
        }
        // this.expQuery.advanceNum = row.advanceNum;
        this.expQuery.advanceId = row.id;
        xz.WriteOffList(this.expQuery).then(res => {
          if (res.status == 'ok') {
            this.expandTable = res.data.data;
          } else {
            this.expandTable = [];
          }
        })
      },
      viewDtl(row) {
        this.expQuery.advanceId = row.id;
        xz.WriteOffList(this.expQuery).then(res => {
          if (res.status == 'ok') {
            this.expandTable = res.data.data;
            this.showWRDtl = true;
          } else {
            this.expandTable = [];
          }
        })
      },
      WriteOffList() {
        this.loading = true;
        xz.WriteOffList(this.listQuery).then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data.data;
            this.totalCount = res.data.pageModel.totalCount;
            this.loading = false;
          } else {
            this.tableData = [];
            this.totalCount = 0;
            this.loading = false;
          }
        })
      },
      toDownFile(url) {
        const newWindow = window.open(url, "_blank");
      },
      editFailInfo(row) {
        this.failForm = {
          AccountName: row.receiptAccountName,
          BankAccount: row.receiptAccount,
          DepositBank: row.depositBank,
          Id: row.id,
          Type: '1',
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
        }
        this.showEditFailInfo = true;
      },
      confirmEdit() {
        this.isBtnLoading = true;
        xz.AdvanceFun(this.failForm, 'UpdateFailedAccountInf').then(res => {
          if (res.status == 'ok') {
            this.$message.success('保存成功')
            this.showEditFailInfo = false;
            this.getList();
            this.isBtnLoading = false;
          } else {
            this.$message.error(res.data)
            this.getList();
            this.showEditFailInfo = false;
            this.isBtnLoading = false;
          }
        })
      },
      del(row) {
        if (!this.loading) {
          this.loading = true;
          let data = {
            type: '1',
            id: row.id,
            userId: Cookies.get("userid-b"),
            roleType: localStorage.loginRoletype,
          }
          xz.AdvanceFun(data, 'CancellApproval').then(res => {
            if (res.status == 'ok') {
              this.getList();
              this.$message.success('作废成功！');
              this.loading = false;
            } else {
              this.getList();
              this.$message.error(res.msg);
              this.loading = false;
            }
          })
        }
      },
      changePersonRespons(row) {
        this.prForm = {
          id: row.id,
          personResponsUserId: '',
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype
        }
        this.showChangePR = true;

      },
      confirmChangePR() {
        this.isBtnLoading = true;
        xz.AdvanceFun(this.prForm, 'changePersonRespons').then(res => {
          if (res.status == 'ok') {
            this.getList();
            this.$message.success('保存成功')
            this.showChangePR = false;
            this.isBtnLoading = false;
          } else {
            this.getList();
            this.$message.error(res.msg)
            this.showChangePR = false;
            this.isBtnLoading = false;
          }
        })
      },
      changeTab2() {
        if (this.activeName2 == '0') {
          this.listQuery.processState = '1';
          this.getList2();
        } else {
          this.listQuery = {
            PageModel: {
              Rows: 10,
              Page: 1,
              OrderInput: []
            },
            ProcessState: '5',
            advanceNum: '',
            advanceId: '',
            BusiType: '1',
            userId: Cookies.get("userid-b"),
            roleType: localStorage.loginRoletype,
          }
          this.getList2();
        }
      },
      delItem(row, index) {
        this.writeOffBatchList.splice(index, 1)
      },
      exportList() {
        let pagename = '';
        if (this.activeName == '部门审核' || this.activeName == '财务核销' || this.activeName == '核销记录' || this.activeName == '核销完毕') {
          pagename = 'ExportWriteOffList'
        } else {
          pagename = 'ExportAdvanceList'
        }
        xz.ExportAdvanceList(this.listQuery, pagename).then(res => {
          try {
            var data = new Blob([res], {
              type: "application/vnd.ms-excel;charset=utf-8"
            });
            var downloadUrl = window.URL.createObjectURL(data);
            var anchor = document.createElement("a");
            anchor.href = downloadUrl;
            anchor.download = this.activeName + "列表.xlsx";
            anchor.click();
            window.URL.revokeObjectURL(data);
            this.loading = false;
          } catch (e) {
            this.loading = false;
            this.$message.error('导出异常')
          }
        })
      },
      downTemp() {
        let path = this.$store.state.EMP.tablePath + 'excel/9c895257-5e33-4888-9bd8-adb6df000386/E20240724134827775.xlsx';
        const aTag = document.createElement('a')
        aTag.href = path;
        aTag.download = "暂支打款结果模版.xlsx";
        aTag.click();
      },
      //下载回单 单个
      downReceiptSingle(row) {
        let now = new Date();
        let payDate = moment(row.applyTime).format('YYYY-MM-DD');
        let nowDate = moment(now).format('YYYY-MM-DD');
        let t1 = new Date(row.applyTime).getTime();
        let t2 = new Date().getTime();
        let offTime = (t2 - t1) / 1000 / 3600;
        let data = {
          bdate: payDate,
          edate: nowDate,
          // datetype: payDate == nowDate ? '0' : '1', //0当天  1隔天
          // accountNo: row.BankAccount,
          accountNo: row.payAccount,
          oppositeAccount: row.receiptAccount
        }
        this.loading = true;
        xz.getpaylistacc(data).then(res => {
          if (res.status == 'ok') {
            if (res.data) {
              setTimeout(() => {
                let d = {
                  business: res.data
                }
                xz.getpdfcont(d).then(r => {
                  if (r.status == 'ok') {
                    this.loading = false;
                    let url = r.data;
                    const aTag = document.createElement('a')
                    aTag.href = url;
                    aTag.download = row.EmployeeName + row.BankAccount + ".xlsx";
                    aTag.click();
                  } else {
                    this.$message.error(offTime < 24 ? r.msg + '请24小时后下载，如有紧急情况，请联系财务' : r.msg)
                    this.loading = false;
                  }
                })
              }, 3000);
            } else {
              this.$message.error(offTime < 24 ? '获取回单失败,请24小时后下载，如有紧急情况，请联系财务' : '获取回单失败')
              this.loading = false;
            }
          } else {
            this.$message.error(offTime < 24 ? res.msg + '请24小时后下载，如有紧急情况，请联系财务' : res.msg)
            this.loading = false;
          }
        })
      },
      downReceipt(row) {
        xz.getElectroniAdvPayment(row.id, localStorage.loginRoletype).then(res => {
          if (res.status == 'ok') {
            let path = 'https://emp.joball.net/cloudimg/' + res.data;
            const aTag = document.createElement('a')
            aTag.href = path;
            aTag.download = row.advanceNum + ".pdf";
            aTag.click();
          } else {
            this.$message.error(res.msg)
          }
        })
      },
      coppBatchPay() {
        if (this.multipleSelection.length < 2) {
          this.$message.warning('请至少选择两个')
        } else {
          this.showCoopTips = true;
        }
      },
      confirmCoopBatchPay() {
        let arr = [];
        this.multipleSelection.forEach((element, index) => {
          arr.push(element.id)
          if (index == this.multipleSelection.length - 1) {
            this.$router.push({
              path: '/coopBatchPay',
              query: {
                ids: arr.toString()
              }
            })
          }
        });
      },
      //修改费用类型
      editCostType(row) {
        this.costForm = {
          Id: row.id,
          Userid: Cookies.get("userid-b"),
          TypeCost: ''
        }
        this.showCostType = true;
      },
      confirmEditCostType() {
        this.isBtnLoading = true;
        xz.UpdtataAdvanceTypeCost(this.costForm).then(res => {
          if (res.status == 'ok') {
            this.$message.success('保存成功');
            this.showCostType = false;
            this.getList()
          } else {
            this.$message.error(res.msg);
            this.showCostType = false;
            this.getList()
          }
        })
      },
      revoke(row) {
        if (!this.loading) {
          this.loading = true;
          let data = {
            type: '1', //1暂支 2日志
            id: row.id,
            userId: Cookies.get("userid-b"),
            roleType: localStorage.loginRoletype,
          }
          xz.AdvanceFun(data, 'RevokingApproval').then(res => {
            if (res.status == 'ok') {
              this.getList();
              this.$message.success('撤销成功！');
              this.loading = false;
            } else {
              this.getList();
              this.$message.error(res.msg);
              this.loading = false;
            }
          })
        }
      },
      viewPic(row) {
        this.picUrl = this.$store.state.EMP.imgPath + 'img' + row.fileUrl;
        this.picPreviewVisible = true;
      },
      closeImageViewer() {
        this.picPreviewVisible = false;
      },
      dowFile(row) {
        let url = this.$store.state.EMP.tablePath + 'excel/' + row.afterSuccesSubmitFileName;
        const aTag = document.createElement("a");
        aTag.href = url;
        aTag.click();
      },

      //杰小金打款/撤回
      jxjApprove(row, apptype) {
        this.appId = row.id;
        this.apptype = apptype;
        this.countdown = 0;
        this.verifCode = '';
        this.isBtnLoading = false;
        this.showSms = true;
      },
      sendSms() {
        xz.ArdCurStatGetFun('SendCodeApproval', `?Id=${this.appId}&Type=2`).then(res => {
          if (res.status == 'ok') {
            this.$message.success('验证码发送成功');
            this.timecount()
          } else {
            this.$message.error(res.msg);
          }
        })
      },
      timecount() {
        const TIME_COUNT = 60; //倒计时60秒
        if (!this.timer) {
          this.countdown = TIME_COUNT;
          this.isDisabled = true;
          this.timer = setInterval(() => {
            if (this.countdown > 0 && this.countdown <= TIME_COUNT) {
              this.countdown--;
            } else {
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      },
      checkSms() {
        if (this.verifCode) {
          this.isBtnLoading = true;
          let str = `?Id=${this.appId}&ApprovalResult=${this.apptype}&VerifCodeStr=${this.verifCode}`;
          xz.ArdCurStatGetFun('UiSubmitReviewAdvResults', str).then(res => {
            if (res.status == 'ok') {
              this.$message.success('操作成功');
              this.isBtnLoading = false;
              this.showSms = false;
              this.getList();
            } else {
              this.$message.error(res.msg);
              this.isBtnLoading = false;
            }
          })
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .expandTable {
    padding-left: 50px;
  }

  .payTips {
    color: red;
    margin-left: 30px;
    font-size: 14px;
    line-height: 32px;
  }

  .tips {
    margin: 0 0 10px 20px;
    font-size: 14px;
  }
</style>
<style>
  .page_tePaymentList .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_tePaymentList .doc_table .el-table__body td.el-table__cell {
    padding: 0;
  }

  .page_tePaymentList .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_tePaymentList .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_tePaymentList .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_tePaymentList .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_tePaymentList .expandTable .el-table__empty-block {
    width: 601px;
    max-width: 601px;
    min-width: 601px;
    padding-right: 0;
  }

  .page_tePaymentList #tab-待核销 {
    background: #FFFF00;
  }

  .page_tePaymentList .el-table__expand-icon {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  /*2.展开按钮未点击的样式是加号带边框*/
  .page_tePaymentList .el-table__expand-icon .el-icon-arrow-right:before {
    content: "\e6d9";
    /* border: 1px solid #19bd92;
    padding: 2px; */
    color: #19bd92;
  }

  /*3.展开按钮点击后的样式是减号带边框*/
  .page_tePaymentList .el-table__expand-icon--expanded .el-icon-arrow-right:before {
    content: "\e6d8";
    color: #19bd92;
  }

  .page_tePaymentList .el-table__expand-icon {
    font-size: 22px;
  }

  .page_tePaymentList .el-table__expand-icon>.el-icon {
    position: static;
    margin: 0 auto;
  }

  .page_tePaymentList .el-table .cell.el-tooltip {
    min-height: 35px;
    line-height: 35px;
  }

  .page_tePaymentList .el-badge__content.is-fixed {
    top: 10px;
    right: 2px;
  }

  .page_tePaymentList .el-table__fixed {
    height: calc(100% - 16px) !important;
  }

  .page_tePaymentList .el-table__fixed:before {
    height: 0px;
  }
</style>